'use strict';

var defaultState = {
    isShowingMobileSearch: false,
    isShowingMobileMenu: false
};

export default function(state = defaultState, action) {

    var newState = {};

    switch (action.type) {

        case 'TOGGLE_MOBILE_MENU':

            newState.isShowingMobileMenu = !state.isShowingMobileMenu;

            if (newState.isShowingMobileMenu && state.isShowingMobileSearch) {

                newState.isShowingMobileSearch = false;
            }

            return Object.assign({}, state, newState);

        case 'TOGGLE_MOBILE_SEARCH':

            newState.isShowingMobileSearch = !state.isShowingMobileSearch;

            if (newState.isShowingMobileSearch && state.isShowingMobileMenu) {

                newState.isShowingMobileMenu = false;
            }

            return Object.assign({}, state, newState);

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./reducers/header.js